module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Parameters</span></div>\r\n<div class=\"col-md-12\" style=\"padding-right:0px; padding-bottom: 10px;\">\r\n	<table id=\"propMainTable\"></table>\r\n	<div id=\"propMainGridButtons\">\r\n		<img class=\"itemNew\" name=\"itemNew\" title=\"new\" src=\"")
    ; __append( require('editor/buttons/gray_new.png') )
    ; __append("\" />\r\n		<img class=\"itemRemove\" name=\"itemRemove\" title=\"remove\" src=\"")
    ; __append( require('editor/buttons/gray_remove.png') )
    ; __append("\" />\r\n	</div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}